<template>
  <!-- TODO: Could oulse the number until all is loaded -->
  <div class="d-flex w-100 mt-2" style="justify-content: space-evenly">
    <filter-item
      v-for="filter in _filters"
      :key="filter"
      :text="filter"
      :count="filterCount(filter)"
      :isActive="activeFilter === filter"
      @click="filterClick(filter)"
      :data-v-tour="`${filter.split(' ').join('')}Link`"
    />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import FilterItem from './FilterItem.vue'
export default {
  components: { FilterItem },
  props: {
    model: {
      type: String,
      default: 'referrals',
    },
    filters: {
      type: Array,
      default: () => ['Needs Action', 'All'],
    },
    hideEmpty: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('auth', ['user']),
    _filters() {
      //TODO: move this condition logic to state
      let filters = []
      const isGp = this.user.practice.specialty == 0
      if (this.model === 'referrals') {
        return this.filters
        if (isGp) {
          if (!this.hideEmpty || this.filterCount('unsent')) filters.push('Unsent')
          filters.push('Sent')
          if (!this.hideEmpty || this.filterCount('to_follow_up')) filters.push('To follow up')
          if (!this.hideEmpty || this.filterCount('received')) filters.push('Received')
        } else {
          filters.push('Received', 'Scheduled', 'Completed')
          if (!this.hideEmpty || this.filterCount('sent')) filters.push('Sent')
        }
        return filters
      }
      if (this.model === 'opreports') {
        filters.push.apply(filters, isGp ? ['Received'] : ['Unsent', 'Sent'])
        if (isGp) {
          if (!this.hideEmpty || this.filterCount('unsent')) filters.push('Unsent')
          if (!this.hideEmpty || this.filterCount('sent')) filters.push('Sent')
        } else {
          if (!this.hideEmpty || this.filterCount('received')) filters.push('Received')
        }
        return filters
      }
      return this.filters
    },
    isLoading() {
      return this.$store.state[this.model].isLoading
    },
    activeFilter: {
      get() {
        return this.$store.state[this.model].activeFilter
      },
      set(value) {
        this.$store.dispatch(this.model + '/filter', value)
      },
    },
    totalCount() {
      return this.$store.state[this.model].totalCount
    },
  },
  async created() {},
  methods: {
    filterClick(f) {
      this.activeFilter = f
      this.$emit('filterChange', f)
    },
    filterCount(filter) {
      if (this.model === 'referrals' && filter === 'All') return this.totalCount
      return this.$store.getters[`${this.model}/filterCount`](filter)
    },
  },
}
</script>
